// extracted by mini-css-extract-plugin
export default {"description":"R8v_oJGhER6zSBxys2mO"};